import React from "react";
import { Link } from "react-router-dom";

const SingleItem = ({
  data,
  index,
  paginateData,
  handleEnableDisabled,
  handleDelete,
}) => {
  return (
    <>
      <tr>
        <td data-label="S.N.">
          {parseFloat(index + 1) +
            parseFloat(paginateData?.page) * parseFloat(paginateData?.limit) -
            10}
        </td>
        <td data-label="Price">{data?.name}</td>

        <td data-label="Status">
          {data?.status ? (
            <span className="badge badge--success text-success">Enabled</span>
          ) : (
            <span>
              <span class="badge badge--warning text-warning">Disabled</span>
            </span>
          )}
        </td>
        <td data-label="Action">
          <Link
            to={`/admin/withdraw/method/network/update/${data._id}`}
            className="btn btn-sm btn-outline-primary editBtn"
          >
            <i className="la la-pencil"></i>Edit
          </Link>

          {data?.status ? (
            <button
              onClick={() => handleEnableDisabled(data._id)}
              className="btn btn-sm btn-outline-danger ms-1 confirmationBtn"
            >
              <i className="la la-eye-slash"></i>Disable
            </button>
          ) : (
            <button
              onClick={() => handleEnableDisabled(data._id)}
              className="btn btn-sm btn-outline-success ms-1 confirmationBtn"
            >
              <i className="la la-eye"></i> Enable
            </button>
          )}
          <button
            className="btn btn-sm btn-outline-danger ms-1"
            onClick={() => handleDelete(data?._id)}
          >
            <i className="la la-trash"></i> Remove
          </button>
        </td>
      </tr>
    </>
  );
};

export default SingleItem;
